import type { PayoutRequestStatus } from "@shopexperts/legacy-api";

export interface PayoutStatusChipAppearance {
  label: string;
  bgClass: string;
  textClass: string;
}

export const payoutStatusChip: Record<PayoutRequestStatus, PayoutStatusChipAppearance> = {
  pending: { label: "Pending", bgClass: "bg-amber-50", textClass: "text-amber-700" },
  done: { label: "Paid", bgClass: "bg-emerald-50", textClass: "text-emerald-700" },
  rejected: { label: "Rejected", bgClass: "bg-rose-50", textClass: "text-rose-700" },
};

export function formatPayoutRequestDate(value: string | null): string {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}
